import React, { useContext, useEffect, useRef, useState } from "react";
import { Context } from "../../context/Context";
import "./Thermostat.css";
import {
  DeleteEquipmentButton,
  DeleteEquipments,
  UpdateEquipmentButton,
  UpdateEquipments,
} from "../../api/api";
import { Link, useNavigate, useParams } from "react-router-dom";
import ThermostatSetTempModal from "../modals/ThermostatSetTempModal";
import SuccessToast from "../toasts/SuccessToast";
import ErrorToast from "../toasts/ErrorToast";
import { MqttContext } from "../../context/MQTTContext";
import WarningAlert from "../sweeAlerts/WarningAlert";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";

const Thermostat = () => {
  const {
    handleThermostatSetTempModal,
    setThermostatSetTempModalType,
    authUser,
    setIsLoading,
    equipmentButtons,
    setEquipmentButtons,
    devices,
    equipments,
    setEquipments,
    handleEquipmentsListModal,
    setSelectedEquipment,
    setChangeNameOptions,
    handleChangeNameModal,
    setChartInfo,
    handleChartModal,
    selectedEquipment,
    update,
    refreshMqtt,
    currentRoom,
  } = useContext(Context);
  const { clients } = useContext(MqttContext);

  const [buttons, setButtons] = useState([]);
  const [editButton, setEditButton] = useState(null);
  const [editedButtonName, setEditedButtonName] = useState("");
  const [changeButton, setChangeButton] = useState(null);
  const [buttonStates, setButtonStates] = useState({});
  const [selectValue, setSelectValue] = useState(null);
  const [changeTemp, setChangeTemp] = useState(false);
  const [ColoredButton, setColoredButton] = useState(null);
  const [editEquipmentName, setEditEquipmentName] = useState(false);
  const [editedEquipmentName, setEditedEquipmentName] = useState("");

  const navigate = useNavigate();

  const { equipment_id: eq_id, room_id, equipment_type: eq_type } = useParams();

  const displayOrder = [0, 1, 2, 3];
  const modeNames = ["خاموش", "روشن", "گرمایش", "سرمایش"];

  useEffect(() => {
    let btns = equipmentButtons
      .filter((eq_btn) => eq_btn.equipment_id == eq_id)
      .map((btn) => ({
        ...btn,
        digit: Number(btn.digit),
      }));

    setButtons(btns);
    setSelectedEquipment({
      id: eq_id,
      type: eq_type,
    });
    if (btns.length) {
      let clientsId = [];
      btns.forEach((button) => {
        let device = devices.find((d) => d.id == button.device_id);
        if (!device) {
          return;
        }

        if (
          device.is_bus == 1 &&
          clients[device?.bridge_device?.id] &&
          !clientsId.includes(device.id)
        ) {
          const messageListener = (topic, message) => {
            const endOfTwoCharToken =
              String.fromCharCode(message[0]) + String.fromCharCode(message[1]);
            const deviceSerial =
              String.fromCharCode(message[3]) +
              String.fromCharCode(message[4]) +
              String.fromCharCode(message[5]) +
              String.fromCharCode(message[6]) +
              String.fromCharCode(message[7]) +
              String.fromCharCode(message[8]);
            if (
              device.bridge_device.internet_token.slice(-2) ===
                endOfTwoCharToken &&
              device.serial === deviceSerial &&
              (message[10] == 1 || message[10] == 3) &&
              message[2] == 14
            ) {
              if (message.length == 36) {
                if (message[12] !== 0 && message[12] !== 1) {
                  ErrorToast("تنظیمات مد کاری دستگاه بررسی شود");
                  clients[device.bridge_device.id].off(
                    "message",
                    messageListener,
                  );
                  return;
                }

                let temp1 =
                  message[11] <= 127
                    ? message[11] / 2
                    : (message[11] - 256) / 2;
                let temp2 =
                  message[16] <= 127
                    ? message[16] / 2
                    : (message[16] - 256) / 2;
                let temp3 =
                  message[21] <= 127
                    ? message[21] / 2
                    : (message[21] - 256) / 2;
                let temp4 =
                  message[26] <= 127
                    ? message[26] / 2
                    : (message[26] - 256) / 2;
                let temp5 =
                  message[31] <= 127
                    ? message[31] / 2
                    : (message[31] - 256) / 2;

                setButtonStates((prevStates) => ({
                  ...prevStates,
                  [device.id]: {
                    1: {
                      temp:
                        temp1 == -64 || temp1 == 255
                          ? "-"
                          : temp1 < -25
                            ? 38.5 - temp1
                            : temp1,
                      status: message[12],
                      mode: message[13],
                      setting_temp: message[14],
                      change_temp: message[15],
                    },
                    2: {
                      temp:
                        temp2 == -64 || temp2 == 255
                          ? "-"
                          : temp2 < -25
                            ? 38.5 - temp2
                            : temp2,
                      status: message[17],
                      mode: message[18],
                      setting_temp: message[19],
                      change_temp: message[20],
                    },
                    3: {
                      temp:
                        temp3 == -64 || temp3 == 255
                          ? "-"
                          : temp3 < -25
                            ? 38.5 - temp3
                            : temp3,
                      status: message[22],
                      mode: message[23],
                      setting_temp: message[24],
                      change_temp: message[25],
                    },
                    4: {
                      temp:
                        temp4 == -64 || temp4 == 255
                          ? "-"
                          : temp4 < -25
                            ? 38.5 - temp4
                            : temp4,
                      status: message[27],
                      mode: message[28],
                      setting_temp: message[29],
                      change_temp: message[30],
                    },
                    5: {
                      temp:
                        temp5 == -64 || temp5 == 255
                          ? "-"
                          : temp5 < -25
                            ? 38.5 - temp5
                            : temp5,
                      status: message[32],
                      mode: message[33],
                      setting_temp: message[34],
                      change_temp: message[35],
                    },
                  },
                }));
                setColoredButton(null);
              }
            }
          };
          // clients[button.device.bridge_device.id].removeAllListeners("message");
          clients[device.bridge_device.id].on("message", messageListener);

          let buffer = new ArrayBuffer(10);
          let asciiCode = new Uint8Array(buffer);
          asciiCode[0] = 14;
          asciiCode[1] = `${device.serial[0]}`.charCodeAt(0);
          asciiCode[2] = `${device.serial[1]}`.charCodeAt(0);
          asciiCode[3] = `${device.serial[2]}`.charCodeAt(0);
          asciiCode[4] = `${device.serial[3]}`.charCodeAt(0);
          asciiCode[5] = `${device.serial[4]}`.charCodeAt(0);
          asciiCode[6] = `${device.serial[5]}`.charCodeAt(0);
          asciiCode[7] = device.type + 50;
          asciiCode[8] = 3;
          asciiCode[9] = 0;

          let message = device.bridge_device.internet_token;

          // ترکیب رشته و بافر
          let combinedMessage = concatenateStringAndBuffer(message, asciiCode);

          clients[device.bridge_device.id].publish(
            device.bridge_device.serial + "/sys",
            combinedMessage,
          );
          clientsId = [...clientsId, device.id];

          setColoredButton(button.id);
        } else if (
          device.id &&
          device.username &&
          device.password &&
          clients[device.id] &&
          !clientsId.includes(device.id)
        ) {
          const messageListener = (topic, message) => {
            const endOfTwoCharToken =
              String.fromCharCode(message[0]) + String.fromCharCode(message[1]);
            if (
              device.internet_token.slice(-2) === endOfTwoCharToken &&
              (message[2] == 3 || message[2] == 1)
            ) {
              if (message.length == 28) {
                if (message[4] !== 0 && message[4] !== 1) {
                  ErrorToast("تنظیمات مد کاری دستگاه بررسی شود");
                  clients[device.id].off("message", messageListener);
                  return;
                }

                let temp1 =
                  message[3] <= 127 ? message[3] / 2 : (message[3] - 256) / 2;
                let temp2 =
                  message[8] <= 127 ? message[8] / 2 : (message[8] - 256) / 2;
                let temp3 =
                  message[13] <= 127
                    ? message[13] / 2
                    : (message[13] - 256) / 2;
                let temp4 =
                  message[18] <= 127
                    ? message[18] / 2
                    : (message[18] - 256) / 2;
                let temp5 =
                  message[23] <= 127
                    ? message[23] / 2
                    : (message[23] - 256) / 2;

                setButtonStates((prevStates) => ({
                  ...prevStates,
                  [device.id]: {
                    1: {
                      temp:
                        temp1 == -64 || temp1 == 255
                          ? "-"
                          : temp1 < -25
                            ? 38.5 - temp1
                            : temp1,
                      status: message[4],
                      mode: message[5],
                      setting_temp: message[6],
                      change_temp: message[7],
                    },
                    2: {
                      temp:
                        temp2 == -64 || temp2 == 255
                          ? "-"
                          : temp2 < -25
                            ? 38.5 - temp2
                            : temp2,
                      status: message[9],
                      mode: message[10],
                      setting_temp: message[11],
                      change_temp: message[12],
                    },
                    3: {
                      temp:
                        temp3 == -64 || temp3 == 255
                          ? "-"
                          : temp3 < -25
                            ? 38.5 - temp3
                            : temp3,
                      status: message[14],
                      mode: message[15],
                      setting_temp: message[16],
                      change_temp: message[17],
                    },
                    4: {
                      temp:
                        temp4 == -64 || temp4 == 255
                          ? "-"
                          : temp4 < -25
                            ? 38.5 - temp4
                            : temp4,
                      status: message[19],
                      mode: message[20],
                      setting_temp: message[21],
                      change_temp: message[22],
                    },
                    5: {
                      temp:
                        temp5 == -64 || temp5 == 255
                          ? "-"
                          : temp5 < -25
                            ? 38.5 - temp5
                            : temp5,
                      status: message[24],
                      mode: message[25],
                      setting_temp: message[26],
                      change_temp: message[27],
                    },
                  },
                }));
                setColoredButton(null);
              }
            }
          };
          // clients[button.device.id].removeAllListeners("message");
          clients[device.id].on("message", messageListener);

          const decimalArray = [3, 0];
          const asciiArray = decimalArray.map((num) =>
            String.fromCharCode(num),
          );

          clients[device.id].publish(
            device.serial + "/sys",
            device.internet_token + asciiArray.join(""),
          );

          setColoredButton(button.id);
          clientsId = [...clientsId, device.id];
        }
      });

      return () => {
        btns.forEach((button) => {
          let device = devices.find((d) => d.id == button.device_id);
          if (!device) {
            return;
          }
          if (device.is_bus == 1 && clients[device?.bridge_device?.id]) {
            clients[device.bridge_device.id].removeAllListeners("message");
          } else if (
            device.id &&
            device.username &&
            device.password &&
            clients[device.id]
          ) {
            clients[device.id].removeAllListeners("message");
          }
        });
      };
    }
  }, [update, equipmentButtons, refreshMqtt, eq_id]); // Add all necessary dependencies

  useEffect(() => {
    if (changeButton) {
      let device = devices.find((d) => d.id == changeButton.device_id);
      if (!device) {
        return;
      }
      if (device.is_bus == 1 && clients[device?.bridge_device?.id]) {
        let buffer = new ArrayBuffer(13);
        let asciiCode = new Uint8Array(buffer);
        asciiCode[0] = 14;
        asciiCode[1] = `${device.serial[0]}`.charCodeAt(0);
        asciiCode[2] = `${device.serial[1]}`.charCodeAt(0);
        asciiCode[3] = `${device.serial[2]}`.charCodeAt(0);
        asciiCode[4] = `${device.serial[3]}`.charCodeAt(0);
        asciiCode[5] = `${device.serial[4]}`.charCodeAt(0);
        asciiCode[6] = `${device.serial[5]}`.charCodeAt(0);
        asciiCode[7] = device.type + 50;
        asciiCode[8] = 1;
        asciiCode[9] = changeButton.digit + 1;
        asciiCode[10] =
          buttonStates[device.id][changeButton.digit + 1].mode % 4;
        asciiCode[11] =
          buttonStates[device.id][changeButton.digit + 1].setting_temp;
        asciiCode[12] =
          buttonStates[device.id][changeButton.digit + 1].change_temp;

        let message = device.bridge_device.internet_token;

        // ترکیب رشته و بافر
        let combinedMessage = concatenateStringAndBuffer(message, asciiCode);
        clients[device.bridge_devices.id].publish(
          device.bridge_device.serial + "/sys",
          combinedMessage,
        );
        setColoredButton(changeButton.id);
      } else {
        let buffer = new ArrayBuffer(5);
        let asciiCode = new Uint8Array(buffer);
        asciiCode[0] = 1;
        asciiCode[1] = changeButton.digit + 1;
        asciiCode[2] = buttonStates[device.id][changeButton.digit + 1].mode % 4;
        asciiCode[3] =
          buttonStates[device.id][changeButton.digit + 1].setting_temp;
        asciiCode[4] =
          buttonStates[device.id][changeButton.digit + 1].change_temp;

        let message = device.internet_token;

        // ترکیب رشته و بافر
        let combinedMessage = concatenateStringAndBuffer(message, asciiCode);
        clients[device.id].publish(device.serial + "/sys", combinedMessage);
        setColoredButton(changeButton.id);
      }
    }
  }, [changeTemp]);

  const concatenateStringAndBuffer = (str, buffer) => {
    let encoder = new TextEncoder();
    let encodedString = encoder.encode(str); // تبدیل رشته به بایت‌ها

    // ساخت یک بافر جدید که به اندازه رشته و بافر اصلی است
    let newBuffer = new Uint8Array(encodedString.length + buffer.byteLength);

    // قرار دادن رشته در ابتدا
    newBuffer.set(encodedString, 0);

    // قرار دادن بافر در ادامه
    newBuffer.set(new Uint8Array(buffer), encodedString.length);

    return newBuffer;
  };

  const handleChangeThermostatMode = (button) => {
    if (buttonStates?.[button.device_id] !== undefined) {
      setButtonStates((prevStates) => {
        const deviceStates = prevStates[button.device_id] || {};
        const currentMode = deviceStates[button.digit + 1]?.mode || 0;
        const nextMode = (currentMode + 1) % 4; // Cycle through 0 to 3

        // Update the mode for this specific button
        return {
          ...prevStates,
          [button.device_id]: {
            ...deviceStates,
            [button.digit + 1]: {
              ...deviceStates[button.digit + 1],
              mode: nextMode,
            },
          },
        };
      });
      let device = devices.find((d) => d.id == button.device_id);
      if (!device) {
        return;
      }
      if (device.is_bus == 1) {
        let buffer = new ArrayBuffer(13);
        let asciiCode = new Uint8Array(buffer);
        asciiCode[0] = 14;
        asciiCode[1] = `${device.serial[0]}`.charCodeAt(0);
        asciiCode[2] = `${device.serial[1]}`.charCodeAt(0);
        asciiCode[3] = `${device.serial[2]}`.charCodeAt(0);
        asciiCode[4] = `${device.serial[3]}`.charCodeAt(0);
        asciiCode[5] = `${device.serial[4]}`.charCodeAt(0);
        asciiCode[6] = `${device.serial[5]}`.charCodeAt(0);
        asciiCode[7] = device.type + 50;
        asciiCode[8] = 1;
        asciiCode[9] = button.digit + 1;
        asciiCode[10] =
          (buttonStates[device.id][button.digit + 1].mode + 1) % 4;
        asciiCode[11] = buttonStates[device.id][button.digit + 1].setting_temp;
        asciiCode[12] = buttonStates[device.id][button.digit + 1].change_temp;

        let message = device.bridge_device.internet_token;

        // ترکیب رشته و بافر
        let combinedMessage = concatenateStringAndBuffer(message, asciiCode);
        clients[device.bridge_device.id].publish(
          device.bridge_device.serial + "/sys",
          combinedMessage,
        );
      } else {
        let buffer = new ArrayBuffer(5);
        let asciiCode = new Uint8Array(buffer);
        asciiCode[0] = 1;
        asciiCode[1] = button.digit + 1;
        asciiCode[2] = (buttonStates[device.id][button.digit + 1].mode + 1) % 4;
        asciiCode[3] = buttonStates[device.id][button.digit + 1].setting_temp;
        asciiCode[4] = buttonStates[device.id][button.digit + 1].change_temp;

        let message = device.internet_token;

        // ترکیب رشته و بافر
        let combinedMessage = concatenateStringAndBuffer(message, asciiCode);
        clients[device.id].publish(device.serial + "/sys", combinedMessage);
      }
      setColoredButton(button.id);
    }
  };

  const handleRemoveButton = (e, button) => {
    setIsLoading(true);
    e.preventDefault();
    DeleteEquipmentButton({
      equipment_button_id: button.id,
    }).then((res) => {
      if (res.status == 200) {
        setEquipmentButtons(equipmentButtons.filter((b) => b.id != button.id));
        SuccessToast("با موفقیت حذف گردید");
        setIsLoading(false);
      }
    });
  };

  const handleChangeNameButton = (button) => {
    const onSubmitFunc = ({ button, name }) => {
      UpdateEquipmentButton({
        equipment_button_id: button.id,
        name: name,
        digit: button.digit,
        icon: button.icon,
      }).then((res) => {
        if (res.status == 200) {
          setEditedButtonName("");
          setEditButton(null);
          SuccessToast("با موفقیت ثبت شد");

          const index = equipmentButtons.findIndex(
            (item) => item.id === button.id,
          );

          if (index !== -1) {
            const updatedButtons = [...equipmentButtons];
            updatedButtons[index] = {
              ...updatedButtons[index],
              name: name,
            };

            setEquipmentButtons(updatedButtons);
          }
        }
      });
    };
    const newOptions = {
      name: button.name,
      onSubmit: (newName) => {
        onSubmitFunc({ button, name: newName });
      },
    };
    setChangeNameOptions(newOptions);
    handleChangeNameModal();
  };
  const handleChangeEquipmentName = (equipment_id) => {
    const onSubmitFunc = ({ equipment_id, name }) => {
      UpdateEquipments({
        equipment_id,
        name,
      }).then((res) => {
        const updatedEquipments = equipments.map((item) =>
          item.id === equipment_id
            ? {
                ...item,
                equipment: { ...item.equipment, name: name },
              }
            : item,
        );
        setEquipments(updatedEquipments);
      });
    };
    const newOptions = {
      name:
        equipments.find((eq) => eq.id == equipment_id)?.equipment.name ?? "",
      onSubmit: (newName) => {
        onSubmitFunc({ equipment_id, name: newName });
      },
    };
    setChangeNameOptions(newOptions);
    handleChangeNameModal();
  };

  const handleRemoveEquipment = (equipment_id) => {
    WarningAlert(
      "آیا از حذف این تجهیز اطمینان دارید؟",
      "",
      "تایید",
      "انصراف",
    ).then(function (result) {
      if (result.value) {
        DeleteEquipments({ equipment_id }).then((res) => {
          SuccessToast(res.data.message);
          let newEquipments = equipments.filter((eq) => eq.id != equipment_id);
          setEquipments(newEquipments);
          let lstEquipment = newEquipments.find(
            (eq) => eq.room_id == currentRoom,
          );
          handleEquipment(lstEquipment, currentRoom);
        });
      }
    });
  };

  const handleEquipment = (equipment, roomId) => {
    if (!equipment) return navigate("/room/" + roomId);
    equipment = equipment.equipment;
    setSelectedEquipment({
      id: equipment.id,
      type: equipment.type,
    });
    if (!equipment) {
      return navigate("/");
    } else if (equipment.type == 1) {
      return navigate(
        "/room/key/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 3) {
      return navigate(
        "/room/remote/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 4) {
      return navigate(
        "/room/dimmer/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 5) {
      return navigate(
        "/room/thermostat/" +
          roomId +
          "/" +
          equipment.id +
          "/" +
          equipment.type,
      );
    } else if (equipment.type == 9) {
      return navigate(
        "/room/rgb/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 99) {
      return navigate(
        "/room/wireless-key/" +
          roomId +
          "/" +
          equipment.id +
          "/" +
          equipment.type,
      );
    } else if (equipment.type == 100) {
      return navigate(
        "/room/television/" +
          roomId +
          "/" +
          equipment.id +
          "/" +
          equipment.type,
      );
    } else if (equipment.type == 501) {
      return navigate(
        "/room/fan-coil/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 401) {
      return navigate(
        "/room/scenario-key/" +
          roomId +
          "/" +
          equipment.id +
          "/" +
          equipment.type,
      );
    } else if (equipment.type == 503) {
      return navigate(
        "/room/humidity/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 502) {
      return navigate(
        "/room/motor/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 9998) {
      return navigate(
        "/room/input/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 9999) {
      return navigate(
        "/room/input-status/" +
          roomId +
          "/" +
          equipment.id +
          "/" +
          equipment.type,
      );
    } else if (equipment.type == 600) {
      return navigate(
        "/room/data-logger/" +
          roomId +
          "/" +
          equipment.id +
          "/" +
          equipment.type,
      );
    }
  };

  const renderButtons = () => {
    return buttons.map((button) => {
      const dev = devices.find((d) => d.id == button.device_id);
      const currentMode =
        buttonStates?.[button.device_id]?.[Number(button.digit + 1)].mode ?? 0;
      const displayMode = displayOrder[currentMode]; // استفاده از ترتیب نمایش جدید
      return (
        <div
          key={button.id}
          className="thermostat mb-1 bg-white"
          style={{
            boxShadow:
              buttonStates?.[button.device_id]?.[Number(button.digit + 1)] !==
                undefined && ColoredButton != button.id
                ? "0 0.25rem 1rem rgba(147, 158, 170, 0.45)"
                : "0 0.25rem 1rem rgba(0, 122, 255, 0.45)",
          }}
        >
          <div className="row p-1">
            <div className="col-1 p-0" style={{ alignContent: "center" }}>
              {authUser.is_admin ? (
                <div
                  className="btn-group d-inline-block"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                  }}
                >
                  <button
                    type="button"
                    className="btn btn-icon rounded-pill dropdown-toggle hide-arrow"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="bx bx-dots-vertical-rounded"></i>
                  </button>
                  <ul className="dropdown-menu ">
                    {dev.is_bus == 0 &&
                    ((dev.fw_version >= 12 && dev.fw_version <= 14) ||
                      dev.fw_version >= 17) ? (
                      <li
                        onClick={(e) => {
                          setChartInfo({
                            type: 1,
                            device_id: button.device_id,
                            chart_num: 1,
                            first_index: button.digit + 1,
                            count: 1,
                            coefficients: [],
                            names: { [button.digit]: button.name },
                          });
                          handleChartModal();
                        }}
                      >
                        <a className="dropdown-item">نمایش نمودار</a>
                      </li>
                    ) : null}

                    <li
                      onClick={() => {
                        handleChangeNameButton(button);
                      }}
                    >
                      <a className="dropdown-item">تغییر نام</a>
                    </li>
                    <li onClick={(e) => handleRemoveButton(e, button)}>
                      <a className="dropdown-item">حذف</a>
                    </li>
                  </ul>
                </div>
              ) : null}
            </div>
            <div className="col my-auto px-0 pe-1">
              <div className="d-flex justify-content-between mb-1">
                <div>
                  <span>تنظیم</span>
                </div>
                <div
                  className="text-center"
                  onClick={() => {
                    setChangeButton(button);
                    setThermostatSetTempModalType(1);
                    setSelectValue(
                      buttonStates?.[button.device_id]?.[button.digit + 1]
                        .setting_temp ?? 0,
                    );
                    handleThermostatSetTempModal(true);
                  }}
                >
                  <span>
                    {buttonStates?.[button.device_id]?.[button.digit + 1]
                      .setting_temp ?? "-"}
                  </span>
                </div>
              </div>
              <div className="d-flex justify-content-between mb-1">
                <div>
                  <span>تغییرات</span>
                </div>
                <div
                  className="text-center"
                  onClick={() => {
                    setChangeButton(button);
                    setThermostatSetTempModalType(2);
                    setSelectValue(
                      buttonStates?.[button.device_id]?.[button.digit + 1]
                        .change_temp ?? 0,
                    );
                    handleThermostatSetTempModal(true);
                  }}
                >
                  <span>
                    {buttonStates?.[button.device_id]?.[button.digit + 1]
                      .change_temp ?? "-"}
                  </span>
                </div>
              </div>
            </div>
            <div
              className="col my-auto text-center px-0"
              onClick={() => handleChangeThermostatMode(button)}
            >
              {displayMode == 0 ? (
                <img
                  src={`/assets/img/app-icons/zs.png`}
                  style={{ width: "30px" }}
                  alt={modeNames[currentMode]}
                />
              ) : displayMode == 1 ? (
                <img
                  src={`/assets/img/app-icons/0q.png`}
                  style={{ width: "30px" }}
                  alt={modeNames[currentMode]}
                />
              ) : displayMode == 2 ? (
                <img
                  src={`/assets/img/app-icons/turn-off-r.png`}
                  style={{ width: "30px" }}
                  alt={modeNames[currentMode]}
                />
              ) : displayMode == 3 ? (
                <img
                  src={`/assets/img/app-icons/turn-on.png`}
                  style={{ width: "30px" }}
                  alt={modeNames[currentMode]}
                />
              ) : null}
            </div>
            <div className="col my-auto px-0">
              <div className="text-center">
                <span dir="ltr">
                  {buttonStates?.[button.device_id]?.[button.digit + 1].temp
                    ? buttonStates?.[button.device_id]?.[button.digit + 1]
                        .temp + "°C"
                    : "-"}
                </span>
              </div>
              <div
                className={
                  buttonStates?.[button.device_id]?.[button.digit + 1].status
                    ? "thermo-status bg-success"
                    : "thermo-status bg-danger"
                }
              ></div>
            </div>
            <div className="col my-auto px-0 pe-1">
              <div className="text-center">
                <p
                  className={
                    editButton == button.id
                      ? "d-none"
                      : "text-center p-0 m-0 d-block"
                  }
                >
                  {button.name}
                </p>
                <div
                  className={
                    editButton == button.id ? "mt-2 d-block" : "d-none"
                  }
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                  }}
                >
                  <div>
                    <input
                      id="smallInput"
                      className="form-control form-control-sm text-center"
                      name="room_name"
                      type="text"
                      placeholder="نام کلید را وارد کنید"
                      value={editedButtonName}
                      onChange={(e) => setEditedButtonName(e.target.value)}
                    />
                  </div>
                  <div className="mt-1">
                    <button
                      type="button"
                      className="btn btn-xs btn-success-app submit-add-room me-2"
                      onClick={() => handleChangeNameButton(button)}
                    >
                      ثبت
                    </button>
                    <button
                      type="button"
                      className="btn btn-xs btn-success-app mt-1"
                      onClick={(e) => setEditButton(null)}
                    >
                      انصراف
                    </button>
                  </div>
                </div>
              </div>
              <div className="text-center">
                <span style={{ fontSize: "11px" }}>
                  C{button.digit + 1}-S/
                  {devices.find((d) => d.id == button.device_id)?.serial}
                </span>
              </div>
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <>
      <div
        className="card h-100"
        style={{ backgroundColor: "#fff0", boxShadow: "none" }}
      >
        <div
          className="card-header d-flex align-items-center justify-content-between border-bottom mb-3 p-0 pt-2"
          style={{ zIndex: "1" }}
        >
          <h5 className={editEquipmentName ? "d-none" : ""}>
            {equipments.find((eq) => eq.id == eq_id)?.equipment?.name ?? ""}
          </h5>
          <div
            className={editEquipmentName ? "mt-2 d-block" : "d-none"}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
          >
            <div>
              <input
                id="smallInput"
                className="form-control form-control-sm text-center"
                name="room_name"
                type="text"
                placeholder="نام تجهیز را وارد کنید"
                value={editedEquipmentName}
                onChange={(e) => setEditedEquipmentName(e.target.value)}
              />
            </div>
            <div className="mt-1">
              <button
                type="button"
                className="btn btn-xs btn-success-app submit-add-room me-2"
                onClick={() =>
                  handleChangeEquipmentName(
                    equipments.find((eq) => eq.id == eq_id)?.id,
                  )
                }
              >
                ثبت
              </button>
              <button
                type="button"
                className="btn btn-xs btn-success-app"
                onClick={(e) => setEditEquipmentName(false)}
              >
                انصراف
              </button>
            </div>
          </div>
          <div>
            {authUser.is_admin ? (
              <>
                <button
                  type="button"
                  className="btn btn-success-app btn-icon me-2"
                  style={{ borderColor: "rgb(0, 165, 148)" }}
                  onClick={() => handleRemoveEquipment(selectedEquipment.id)}
                >
                  <i className="bx bx-trash"></i>
                </button>
                <div className="btn-group">
                  <button
                    type="button"
                    className="btn btn-success-app btn-icon dropdown-toggle hide-arrow"
                    style={{ borderColor: "rgb(0, 165, 148)" }}
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="bx bx-dots-vertical-rounded"></i>
                  </button>
                  <ul className="dropdown-menu dropdown-menu-end">
                    <li>
                      <Link
                        className="dropdown-item"
                        onClick={(e) => {
                          e.preventDefault();
                          handleEquipmentsListModal(true);
                        }}
                      >
                        افزدون تجهیز
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item"
                        to={
                          "/room/select-device/" +
                          room_id +
                          "/" +
                          eq_id +
                          "/" +
                          eq_type
                        }
                      >
                        افزدون کانال به تجهیز
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item"
                        onClick={() =>
                          handleChangeEquipmentName(
                            equipments.find((eq) => eq.id == eq_id)?.id,
                          )
                        }
                      >
                        تغییر نام تجهیز
                      </Link>
                    </li>
                  </ul>
                </div>
              </>
            ) : null}

            {/* <BackButton url={"/room/" + room_id} /> */}
          </div>
        </div>
        <div
          className="card-body scrollbar mt-sm-2"
          style={{ paddingBottom: "10rem" }}
        >
          {/* <SimpleBar style={{ maxHeight: "100%", padding: "1.5rem" }}> */}
          {renderButtons()}
          {/* </SimpleBar> */}
        </div>
      </div>
      <ThermostatSetTempModal
        changeButton={changeButton}
        setChangeButton={setChangeButton}
        buttonStates={buttonStates}
        setButtonStates={setButtonStates}
        selectValue={selectValue}
        changeTemp={changeTemp}
        setChangeTemp={setChangeTemp}
      />
    </>
  );
};

export default React.memo(Thermostat);
